// extracted by mini-css-extract-plugin
export var alertIcon = "_v1-0";